import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Input, Select, Button, DatePicker, PaperClip } from 'components';
import Slider2 from '../../assets/img/slider2.jpg';
import { Elements, CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import { PaymentImage, BFCLogo, StripeLogo, Logo } from 'assets/img';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { PublicPaymentService } from 'services';

declare var Stripe: any;
const stripe = Stripe(process.env.REACT_APP_STRIPE_KEY || '');

interface MatchParams {
	code: string;
}

interface Props extends RootState, RouteComponentProps<MatchParams> {
	dispatch: any;
	stripe?: any;
	elements?: any;
}

class PublicPayment extends React.Component<Props> {

	elements: any;

	state = {
		banks: [],
		payment_methods: [],
		bank_accounts: [],
		form: {
			payment_method_id: Constants.PAYMENT_METHODS.MOVIL,
			payment_email: '',
			payment_phone: '',
			payment_date: '',
			payment_bank_id: '',
			payment_reference: '',
			payment_photo: '',
			payment_bank_account_id: '',
			payment_name: ''
		},
		code: this.props.match.params.code,
		quote: {
			price: 0
		},
		quotes: []
	}

	async componentDidMount() {
		this.load();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	load = async () => {
		const res: any = await PublicPaymentService.get({
			code: this.state.code
		});
		if (res._continue) {
			const { ZELLE, CASH2, MOVIL, TRANSFER, STRIPE } = Constants.PAYMENT_METHODS;
			
			this.setState({
				banks: res.banks,
				payment_methods: res.payment_methods.filter((i: any) => [ZELLE,TRANSFER, CASH2, STRIPE, MOVIL].indexOf(i.id) != -1),
				bank_accounts: res.bank_accounts,
				quote: res.quote,
				quotes: res.quotes
			});
		}
		else {
			this.props.history.replace('/');
		}
	}

	submit = async () => {
		let token = null;

		if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH2) {
			if (!this.state.form.payment_photo) {
				Globals.showError("Debe ingresar la foto de los billetes");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.MOVIL) {
			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha del pago");
				return;
			}

			if (!this.state.form.payment_phone) {
				Globals.showError("Debe ingresar el teléfono del pago móvil");
				return;
			}

			if (!this.state.form.payment_bank_id) {
				Globals.showError("Debe ingresar el banco del pago móvil");
				return;
			}

			if (!this.state.form.payment_reference) {
				Globals.showError("Debe ingresar el número de referencia");
				return;
			}

			// if (!this.state.form.payment_photo) {
			// 	Globals.showError("Debe ingresar la foto del pago");
			// 	return;
			// }
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER) {
			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha del pago");
				return;
			}

			if (!this.state.form.payment_bank_id) {
				Globals.showError("Debe ingresar el banco de la transferencia");
				return;
			}

			if (!this.state.form.payment_reference) {
				Globals.showError("Debe ingresar el número de referencia");
				return;
			}

			if (!this.state.form.payment_photo) {
				Globals.showError("Debe ingresar la foto del pago");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.ZELLE) {
			if (!this.state.form.payment_name) {
				Globals.showError("Persona que realizó el pago");
				return;
			}

			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha de pago");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.BFC) {
			return;
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH) {
			if (!this.state.form.payment_bank_account_id) {
				Globals.showError("Debe ingresar la cuenta bancaria");
				return;
			}

			if (!this.state.form.payment_date) {
				Globals.showError("Debe ingresar la fecha del pago");
				return;
			}

			if (!this.state.form.payment_reference) {
				Globals.showError("Debe ingresar el número de referencia");
				return;
			}
		}
		else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE) {
		    Globals.setLoading();

		    try {
		    	const card = this.props.elements.getElement('card');
		    	const response = await stripe.createToken(card);

		    	token = response?.token?.id;
		    }
		    catch(e) {
		    	console.log(e);
		    	Globals.quitLoading();
		    	Globals.showError("Lo sentimos, no se pudo procesar su pago");
		    	return;
		    }		    
		}

		const is_stripe = this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE;

		const res: any = await PublicPaymentService.save({
			// @ts-ignore
			quote_id: this.state.quote?.id,
			quotes_ids: this.state.quotes.map((i: any) => i.id),
			...this.state.form,
			hasFile: true,
			withoutLoading: is_stripe,
			// @ts-ignore,
			payment_photo: this.state.form.payment_photo?.value || '',
			payment_date: this.state.form.payment_date && moment(this.state.form.payment_date).format('YYYY-MM-DD'),
			token
		}).catch(err => {
			Globals.quitLoading();
		});

		if (is_stripe)
			Globals.quitLoading();

		if (res?.result) {
			this.props.history.replace('/');
			Globals.showSuccess("El pago se ha realizado correctamente");
		}
	}
	
	render() {
		const payment_movil: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.MOVIL);
		const bank_account: any = this.state.bank_accounts.find((i: any) => i.id == this.state.form.payment_bank_account_id);
		const transfer: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.TRANSFER);
		const payment_zelle: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.ZELLE);
		const random_number = Globals.randomString(6);

		let price = 0;

		if (this.state.quotes.length > 0) {
			price = this.state.quotes.map((i: any) => i.price).reduce((a: number, b: number) => a + b,0);
		}
		else {
			price = this.state.quote?.price;
		}

		return (
			<div id="public-payment">
				<div className="row row-payment">
					<div className="col-md-12">
						<div className="container-logo">
							<img src={ Logo } />
						</div>
						<h3>Completa tu pago</h3>

						<div className="row row-payment-methods">
							{
								this.state.payment_methods.map((item: any) => {
									return (
										<>
											{
												item != null && (
													<div className="col-md-6">
														<button className={ `btn btn-blue ${ this.state.form.payment_method_id == item.id ? 'active' : '' }` } onClick={ () => this.setState({
															form: {
																...this.state.form,
																payment_method_id: item.id
															}
														}) }>
															<img src={ Constants.BASE_PUBLIC + item.photo } />
															{ item.name }
														</button>
													</div>
												)
											}
										</>
									)
								})
							}
						</div>

						{
							// @ts-ignore
							this.state.form.payment_method_id == Constants.PAYMENT_METHODS.MOVIL && (
								<React.Fragment>			
									<div className="row row-payments">
										<div className="col-md-8">
											<h6>Datos para el pago</h6>
											<p>{ payment_movil?.bank?.name } - { payment_movil?.bank?.code }</p>
											<p>{ payment_movil?.document_type?.name + payment_movil?.document }</p>
											<p>{ payment_movil?.phone }</p>
										</div>
										<div className="col-md-4 text-right">
											<h6>Total a pagar</h6>
											<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
										</div>
									</div>						
									<div className="row">
										<div className="col-12">
											<h5>Confirmar pago</h5>
											<Select
												label="Banco"
												name="payment_bank_id"
												onChange={ (e: any) => this.change(e) }
												value={ this.state.form.payment_bank_id }
												options={ this.state.banks.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
										</div>
										<div className="col-md-6">
											<DatePicker
												label="Fecha"
												maxDate={ moment().toDate() }
												onChange={ (text: string) => {
													this.change({
														target: {
															value: text,
															name: 'payment_date'
														}
													});
												} }
												value={ this.state.form.payment_date }
											/>
										</div>
										<div className="col-md-6">
											<Input
												type="number"
												color="white"
												value={ this.state.form.payment_phone }
												name="payment_phone" 
												label="Teléfono"
												maxLength={ 11 }
												onChange={ this.change } />
										</div>
										<div className="col-12">
											<PaperClip
												value={this.state.form.payment_photo}
												successText={`Foto Adjuntada`}
												pendingText={`Subir comprobante (Opcional)`}
												onChange={(e: any) => {
													this.setState({
														form: {
															...this.state.form,
															payment_photo: e.target
														}
													})
												}} />
										</div>
										<div className="col-12">
											<Input
												className="reference"
												type="number"
												color="white"
												value={ this.state.form.payment_reference }
												name="payment_reference" 
												maxLength={ 4 }
												placeholder="Últimos 4 dígitos de referencia"
												onChange={ this.change } />
										</div>
									</div>
								</React.Fragment>
							)
						}

						{
							// @ts-ignore
							this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE && (
								<React.Fragment>	
									<div className="row row-payments">
										<div className="col-md-12 text-right">
											<h6>Total a pagar</h6>
											<p className="total">{ Globals.formatMiles(price) }</p>
										</div>
									</div>
									<div className="row">		
										<div className="col-md-12">
											<div className="container-logo-stripe">
												<img src={ StripeLogo } />
											</div>
										</div>
										<div className="col-md-12">
											<div className="card-element-stripe">
												<CardElement options={{
													hidePostalCode: true
												}} />
											</div>
										</div>
									</div>
								</React.Fragment>
							)
						}

						{
							// @ts-ignore
							this.state.form.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER && (
								<React.Fragment>			
									<div className="row row-payments">
										<div className="col-md-8">
											<h6>Datos para el pago</h6>
											<p>{ transfer?.account_name }</p>
											<p>{ transfer?.bank?.name } - { transfer?.bank?.code }</p>
											<p>{ transfer?.account_number }</p>
											<p>{ transfer?.document_type?.name + transfer?.document }</p>
										</div>
										<div className="col-md-4 text-right">
											<h6>Total a pagar</h6>
											<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
										</div>
									</div>						
									<div className="row">
										<div className="col-12">
											<h5>Confirmar pago</h5>
										</div>
										<div className="col-md-6">
											<Select
												label="Banco"
												name="payment_bank_id"
												onChange={ (e: any) => this.change(e) }
												value={ this.state.form.payment_bank_id }
												options={ this.state.banks.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
										</div>
										<div className="col-md-6">
											<DatePicker
												label="Fecha"
												maxDate={ moment().toDate() }
												onChange={ (text: string) => {
													this.change({
														target: {
															value: text,
															name: 'payment_date'
														}
													});
												} }
												value={ this.state.form.payment_date }
											/>
										</div>
										<div className="col-12">
											<PaperClip
												value={ this.state.form.payment_photo }
												successText={ `Foto Adjuntada` }
												pendingText={ `Imagen del pago` }
												onChange={ (e: any) => {
													this.setState({
														form: {
															...this.state.form,
															payment_photo: e.target
														}
													})
												} } />
										</div>
										<div className="col-12">
											<Input
												className="reference"
												type="number"
												color="white"
												value={ this.state.form.payment_reference }
												name="payment_reference" 
												maxLength={ 4 }
												placeholder="Últimos 4 dígitos de referencia"
												onChange={ this.change } />
										</div>
									</div>
								</React.Fragment>
							)
						}

						{
							// @ts-ignore
							this.state.form.payment_method_id == Constants.PAYMENT_METHODS.ZELLE && (
								<React.Fragment>
									<div className="row row-payments">
										<div className="col-md-8">
											<h6>Datos para el pago</h6>
											<p>{ payment_zelle?.email }</p>
										</div>
										<div className="col-md-4 text-right">
											<h6>Total a pagar</h6>
											<p className="total">{ Globals.formatMiles(price) }</p>
										</div>
									</div>
									<div className="row">
										<div className="col-12">
											<h5>Confirmar pago</h5>
										</div>
										<div className="col-md-6">
											<DatePicker
												label="Fecha de pago"
												maxDate={ moment().toDate() }
												onChange={ (text: string) => {
													this.change({
														target: {
															value: text,
															name: 'payment_date'
														}
													});
												} }
												value={ this.state.form.payment_date }
											/>
										</div>
										<div className="col-md-6">
											<Input
												color="white"
												label="Persona que realizó el pago"
												value={ this.state.form.payment_name }
												name="payment_name" 
												placeholder="Nombre"
												onChange={ this.change } />
										</div>
										<div className="col-12">
											<PaperClip
												value={ this.state.form.payment_photo }
												successText={ `Foto Adjuntada` }
												pendingText={ `Imagen del pago` }
												onChange={ (e: any) => {
													this.setState({
														form: {
															...this.state.form,
															payment_photo: e.target
														}
													})
												} } />
										</div>
									</div>
								</React.Fragment>
							)
						}

						{
							// @ts-ignore
							this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH && (
								<React.Fragment>			
									<div className="row row-payments">
										{
											bank_account && (
												<div className="col-md-12" style={{ marginBottom: '20px' }}>
													<h6>Datos para el pago</h6>
													<p>{ bank_account?.number }</p>
													<p>{ bank_account?.bank?.name } - { bank_account?.bank?.code }</p>
												</div>
											)
										}
										<div className="col-md-6">
											<Select
												label="Cuenta bancaria"
												name="payment_bank_account_id"
												onChange={ (e: any) => this.change(e) }
												value={ this.state.form.payment_bank_account_id }
												options={ this.state.bank_accounts.map((i: any) => {
													return {
														value: i.id,
														label: i.number + ' - ' + i.bank?.name
													}
												}) } />
										</div>
										<div className="col-md-6 text-right">
											<h6>Total a pagar</h6>
											<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
										</div>
										<div className="col-md-12">
											<DatePicker
												label="Fecha"
												maxDate={ moment().toDate() }
												onChange={ (text: string) => {
													this.change({
														target: {
															value: text,
															name: 'payment_date'
														}
													});
												} }
												value={ this.state.form.payment_date }
											/>
										</div>
										<div className="col-12">
											<Input
												className="reference"
												type="number"
												color="white"
												value={ this.state.form.payment_reference }
												name="payment_reference" 
												placeholder="Número de confirmación"
												onChange={ this.change } />
										</div>
									</div>
								</React.Fragment>
							)
						}

						{
							// @ts-ignore
							this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH2 && (
								<React.Fragment>
									<div className="row row-payments">
										<div className="col-md-12 text-right">
											<h6>Total a pagar</h6>
											<p className="total">{ Globals.formatMiles(price) }</p>
										</div>
									</div>
									<div className="row">
										<div className="col-12">
											<h5>Confirmar pago</h5>
										</div>
										<div className="col-12">
											<PaperClip
												value={ this.state.form.payment_photo }
												successText={ `Foto Adjuntada` }
												pendingText={ `Imagen de los billetes` }
												onChange={ (e: any) => {
													this.setState({
														form: {
															...this.state.form,
															payment_photo: e.target
														}
													})
												} } />
										</div>
									</div>
								</React.Fragment>
							)
						}

						<div className="row row-buttons-submit">
							<div className="col-md-12 text-center">
								<button className="btn btn-save" onClick={ () => this.submit() }>
									Confirmar
								</button>		
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const Payment = connect((state: RootState) => {
	return {
		conversion: state.conversion
	}
})(PublicPayment);

export default function StripeContainer(props: Props) {
  return (
  	<Elements stripe={ stripe }>
	    <ElementsConsumer>
	      {({stripe, elements}) => (
	        <Payment { ...props } stripe={ stripe } elements={ elements } />
	      )}
	    </ElementsConsumer>
	</Elements>
  )
}